import { SIGNATURE_FONTS, type AdoptedSignature } from "@gsignatures/core";
import type { CSSProperties } from "react";
import { S } from "../strings";

export function fontFor(id: string) {
  return SIGNATURE_FONTS.find((f) => f.id === id) ?? SIGNATURE_FONTS[0];
}

/** The adopted signature, as ink: the typed name in its font, or the drawn / uploaded image. */
export function SigInk({ sig, className = "", fontSize, animate }: { sig: AdoptedSignature | undefined; className?: string; fontSize?: string; animate?: boolean }) {
  if (!sig) return null;
  const cls = `${className} ${animate ? "ink-in" : ""}`.trim();
  if (sig.kind === "image") return <img className={`sig-img ${cls}`} src={sig.url} alt={S.adopt.alt} draggable={false} />;
  const f = fontFor(sig.font);
  const style: CSSProperties = { fontFamily: `"${f.family}", cursive`, ...(fontSize ? { fontSize } : {}) };
  return (
    <span className={`sig-ink ${cls}`} style={style} role="img" aria-label={`${S.adopt.alt}: ${sig.text}`}>
      {sig.text}
    </span>
  );
}
